import * as React from 'react';
import classNames from 'classnames';
import * as _ from 'lodash';

import * as Edge from '../../core';
import Select from '../../components/global/select';
import { Constants } from '../../core';

import './index.scss';

export interface TeamPickerProps {
	className?: string;
	createTeam?: () => void;
	currentTeam?: Edge.Models.Team;
	placeholderForCurrentTeam?: string;
	setCurrentTeam: (team: Edge.Models.Team) => void;
	showOrderBy?: boolean;
	teams?: Edge.Models.Team[];
}

interface TeamPickerState {
	orderAsc: boolean;
}

export default class TeamPicker extends React.Component<TeamPickerProps, TeamPickerState> {
	constructor(props: TeamPickerProps) {
		super(props);
		this.state = {
			orderAsc: (props.teams || []).length < Edge.Constants.ORDER_ASCENDING_MAXIMUM_TEAM_COUNT,
		};
	}

	public render(): JSX.Element {
		const { showOrderBy } = this.props;
		return showOrderBy ? (
			<div className="teamPicker">
				{this.renderSelector()}
				<button className="cta_btn btn_small" onClick={() => this.setState({ orderAsc: !this.state.orderAsc })}>
					{this.state.orderAsc ? '↓' : '↑'}
				</button>
			</div>
		) : (
			this.renderSelector()
		);
	}

	private changeTeam = (e: React.ChangeEvent<HTMLSelectElement>) => {
		if (e.target.value === '_') {
			const { createTeam } = this.props;
			if (createTeam) {
				createTeam();
			}
		} else {
			const currentTeam = (this.props.teams || []).filter((i) => i.id === e.target.value)[0];
			this.props.setCurrentTeam(currentTeam);

			// Allows for the persistence of selected teams when using this component.
			const orgTeamIdsString = localStorage.getItem(Constants.LOCALSTORAGE_ORG_CURRENT_TEAM_IDS);
			const orgTeamIds = !!orgTeamIdsString ? JSON.parse(orgTeamIdsString) : {};
			Object.assign(orgTeamIds, {
				[currentTeam.organizationId]: currentTeam.id,
			});
			localStorage.setItem(Constants.LOCALSTORAGE_ORG_CURRENT_TEAM_IDS, JSON.stringify(orgTeamIds));
		}
	};

	private renderSelector = () => {
		const { currentTeam, teams, createTeam, placeholderForCurrentTeam } = this.props;
		return (
			<Select
				value={currentTeam && currentTeam.id}
				onChange={this.changeTeam}
				className={classNames(this.props.className)}
			>
				{teams &&
					teams.length > 0 &&
					_.orderBy(teams, (t: Edge.Models.Team) => t.name, this.state.orderAsc ? 'asc' : 'desc').map(
						(t: Edge.Models.Team) =>
							placeholderForCurrentTeam && currentTeam && t.id === currentTeam.id ? (
								<option key={currentTeam.id} disabled value={currentTeam.id} hidden>
									{placeholderForCurrentTeam}
								</option>
							) : (
								<option key={t.id} value={t.id}>
									{t.name}
								</option>
							)
					)}
				{createTeam && (
					<option key={'_'} value="_">
						Create New Team
					</option>
				)}
			</Select>
		);
	};
}
